/** APP_STORE_LINKS_FOLLOWUP read-only display: clickable links to the published
 *  App Store / Play Store listings once their URLs are set. Editing the URLs is
 *  handled by the generic inline field editor (config_fields) alongside this.
 */
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Box, Link, Stack, Typography } from '@mui/material';

import type { PreflightItem } from '@/api/preflight';

function StoreLink({ url, label }: { url: string | null; label: string }) {
  if (!url) {
    return (
      <Typography variant="body2" color="text.secondary">
        {label}: not set yet — add the URL below once the app is live.
      </Typography>
    );
  }
  return (
    <Link
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      variant="body2"
      sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.25 }}
    >
      <OpenInNewIcon sx={{ fontSize: 14 }} />
      Open {label}
    </Link>
  );
}

export function AppStoreLinksDisplay({ item }: { item: PreflightItem }) {
  const ios = typeof item.detail.ios_app_link === 'string' ? item.detail.ios_app_link : null;
  const android = typeof item.detail.android_app_link === 'string' ? item.detail.android_app_link : null;

  return (
    <Box sx={{ mb: 1.5 }}>
      <Stack spacing={0.5}>
        <StoreLink url={ios} label="App Store listing" />
        <StoreLink url={android} label="Play Store listing" />
      </Stack>
    </Box>
  );
}
